import { gql } from "@apollo/client";

export const DELETE_GROUP = gql`
  mutation deleteGroup($input: DeleteSkynetUserGroupInput!) {
    rolesAndPermissions {
      deleteGroup(input: $input) {
        success
      }
    }
  }
`;
